//@flow
import {ActionCreator, createReducer} from '../../store/utils';

import type {Action} from '../../store/utils';

export type ToastType =
  | 'warning'
  | 'success'
  | 'danger'
  | 'info'
  | 'default'
  | 'primary';

export type ToastAction = {
  label: string,
  onClick: () => void,
};

export type ToastAlert = {
  type: ToastType,
  title: string,
  message: string,
  duration?: number,
  onClose?: () => void,
  action?: ToastAction,
};

export type ToastAlertState = {
  toast: ToastAlert,
};

export type ToastAlertActions = Action & {
  toast?: ToastAlert,
};

export class ShowToastAlert extends ActionCreator<ToastAlertActions> {}
export class CloseToastAlert extends ActionCreator<ToastAlertActions> {}

export const actions = {
  showToastAlert: (toast: ToastAlert) => new ShowToastAlert({toast}),
  closeToastAlert: () => new CloseToastAlert(),
};

export const initialState: ToastAlertState = {};

export default createReducer(initialState, {
  [ShowToastAlert.type]: (
    state: ToastAlertState,
    action: ToastAlertActions
  ) => {
    return {
      ...state,
      toast: action?.toast,
    };
  },
  [CloseToastAlert.type]: (state: ToastAlertState) => {
    return {
      ...state,
      toast: undefined,
    };
  },
});
